import isDetachedNodeError from './isDetachedNodeError'

const RETRY_WINDOW_MS = 10000

let lastRetryAt = 0
let decisions = new WeakMap()

// Idempotent per error object so repeated renders of the same error agree,
// and rate-limited so a persistently failing tree cannot loop forever.
export function shouldAutoRetry(error, now = Date.now()) {
  if (!error || typeof error !== 'object') return false
  if (decisions.has(error)) return decisions.get(error)

  const retry = isDetachedNodeError(error) && now - lastRetryAt >= RETRY_WINDOW_MS
  if (retry) lastRetryAt = now
  decisions.set(error, retry)
  return retry
}

export function resetAutoRetryForTests() {
  lastRetryAt = 0
  decisions = new WeakMap()
}
